import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import RoleElevationRequestForm from '../components/RoleElevationRequestForm';
import { loadRoleList } from '../api/userapi';
import {  getUserDetailsLoading, getUserDetails, getRolesList } from "../selector/selectors";
import LoaderComponent from '../components/LoaderComponent';
import { loadUserInformation, roleUpdateRequest } from '../api/elevationapi';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';

const CreateRoleElevationRequest = ({
    isLoading,
    roleList,
    userDetails,
    startLoadingRole,
    startLoadingUserInformation
}) => {

    const dispatch = useDispatch();
    const [value, setValue] = React.useState('1');
    const [userData, setUserData] = useState({
        old_role_id : '',
        new_role_id   : '',
        message     : '',
        location    : '',
    });
    const [updatedRoleList, setUpdatedRoleList]  = React.useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        let roleUpdateList = roleList?.data?.filter(val => val.role_type === '1' &&  val.id !== userDetails?.data?.role_id);
         setUpdatedRoleList(roleUpdateList);
    },[roleList,userDetails])

    useEffect(() => {
        startLoadingUserInformation();
        startLoadingRole();
    }, [startLoadingRole,startLoadingUserInformation]);

    const changeHandler = (e) => {
        setUserData((prevState) => ({...prevState, [e.target.name]: e.target.value }));
    }

    const handleFormData = async () => {
        if(userData.role_type === ''){
          swal("Oops!", "Please select new Role!", "error");
          return false;
        }
        if(userData.role_type === 4 && userData.location === ''){
            swal("Oops!", "Please select Location!", "error");
            return false;
        }
        userData.old_role_id = userDetails?.data?.role_id;
        dispatch(roleUpdateRequest(userData));
        setUserData({new_role_id:"", message:""});
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Tab label="Role Elevation Request" value="1" />
                                <Link className="tabingLinks" to="/web/permission/request">Permissions Request</Link>
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <RoleElevationRequestForm 
                                roleList={updatedRoleList} 
                                userDetails={userDetails}  
                                handleFormData={handleFormData} 
                                changeHandler={changeHandler}
                                userData={userData}
                            />
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>
        </Box>
    )
}

const mapStateToProps = (state) => ({
    isLoading        :   getUserDetailsLoading(state),  
    userDetails      :   getUserDetails(state), 
    roleList         :   getRolesList(state), 
});
  
const mapDispatchToProps = (dispatch) => ({
    startLoadingRole:()             => dispatch(loadRoleList()),
    startLoadingUserInformation:()  => dispatch(loadUserInformation()),
});
  
export default connect(mapStateToProps, mapDispatchToProps)(CreateRoleElevationRequest);